angular.module('iqxCore')
.directive ('a', function ($route, $location) {
	var d = {}
	d.restrict = 'E'
	d.link = function (scope, elem, attrs) {
		if ('target' in attrs) return

		if (!('href' in attrs)) return

		var href = elem [0].href
		elem.bind ('click', function () {
			if (href !== $location.absUrl ()) return
			$route.reload ()
		})
	}
	return d
})

.directive('capitalize', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attrs, modelCtrl) {
			var capitalize = function (inputValue) {
				if (inputValue == undefined) inputValue = ''
				var capitalized = inputValue.toUpperCase()
				if (capitalized !== inputValue) {
					modelCtrl.$setViewValue(capitalized)
					modelCtrl.$render()
				}
				return capitalized
			}
			modelCtrl.$parsers.push(capitalize)
			capitalize(scope[attrs.ngModel])
		}
	}
})